import { faL } from '@fortawesome/free-solid-svg-icons';
import React, { useState } from 'react';
import { LuNotebookText } from "react-icons/lu";
import { MdDownload } from "react-icons/md";


const DisbursementSheet = ({ reportData }) => {
    const [loading, setLoading] = useState(false)
    const downloadCSV = () => {
        if (!reportData?.data?.length) return;
        setLoading(true)
        // headers (Sr no. bhi add kiya)
        const headers = ["Sr no.", ...Object.keys(reportData.data[0])].join(",");

        // rows with Sr no.
        const rows = reportData.data.map((obj, index) =>
            [index + 1, ...Object.values(obj)].join(",")
        );

        // final csv
        const csv = [headers, ...rows].join("\n");

        // download
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "payment-report.csv";
        link.click();
        setInterval(() => {
            setLoading(false)
        }, 1000)
    };

    return (
        Array.isArray(reportData?.data) && reportData.data.length !== 0 ? (
            <div className="flex flex-col gap-6 p-4 md:p-10 my-10">
                <div
                    className="overflow-x-auto bg-white shadow-md rounded-xl p-4 md:p-8 border border-gray-200"
                >
                    <h2 className="font-bold text-[#1D3E50] mb-7 flex items-center gap-2 text-lg md:text-2xl">
                        <LuNotebookText /> Disbursement Sheet Report
                    </h2>
                    <table className="w-full table-auto w-full text-sm border-collapse">
                        <thead className='bg-[#1D3E50] text-lg'>
                            <th className='px-4 py-3 text-white text-medium whitespace-nowrap'>Sr no.</th>
                            <th className='px-4 py-3 text-white text-medium whitespace-nowrap text-center'>Amount</th>
                            <th className='px-4 py-3 text-white text-medium whitespace-nowrap'>Bank</th>
                            <th className='px-4 py-3 text-white text-medium whitespace-nowrap'>Bank Account</th>
                            <th className='px-4 py-3 text-white text-medium whitespace-nowrap'>Beneficiary Name</th>
                            <th className='px-4 py-3 text-white text-medium whitespace-nowrap text-center'>Date</th>
                            <th className='px-4 py-3 text-white text-medium whitespace-nowrap text-center'>IFSC</th>
                            <th className='px-4 py-3 text-white text-medium whitespace-nowrap text-center'>Payment Mode</th>
                        </thead>

                        <tbody>
                            {reportData.data.map((report, index) => (
                                <tr className='border-t border-gray-300 hover:bg-[#EDF3F6]'>
                                    <td className='p-4 border font-medium text-[#1D3E50] whitespace-nowrap'>{index + 1}.</td>
                                    <td className='p-4 border font-medium text-[#1D3E50] whitespace-nowrap text-center'>{report['Amount']}</td>
                                    <td className='p-4 border font-medium text-[#1D3E50] whitespace-nowrap'>{report['Bank']}</td>
                                    <td className='p-4 border font-medium text-[#1D3E50] whitespace-nowrap'>{report['Bank Account']}</td>
                                    <td className='p-4 border font-medium text-[#1D3E50] whitespace-nowrap'>{report['Beneficiary Name']}</td>
                                    <td className='p-4 border font-medium text-[#1D3E50] whitespace-nowrap text-center'>{report['Date']}</td>
                                    <td className='p-4 border font-medium text-[#1D3E50] whitespace-nowrap text-center'>{report['IFSC']}</td>
                                    <td className='p-4 border font-medium text-[#1D3E50] whitespace-nowrap text-center'>{report['Payment Mode']}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <button
                        className="mx-auto block mt-10 bg-[#1D3E50] hover:bg-[#164056] border-0 hover:!text-white hover:!bg-[#1D3E50] hover:!border-0 text-white font-medium px-5 py-2  rounded-lg transition-colors"
                        onClick={downloadCSV}
                    >
                        {loading ? (
                            <div className='flex gap-2 items-center'>
                                <svg
                                    className="animate-spin h-5 w-5 text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                >
                                    {/* Simplified path - faster rendering */}
                                    <path
                                        fill="currentColor"
                                        d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                                        opacity="0.25"
                                    />
                                    <path
                                        fill="currentColor"
                                        d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
                                    />
                                </svg>
                                Downloading...
                            </div>
                        ) : (<span className="flex gap-2 items-center"><MdDownload className="text-xl" /> Download Report</span>
                        )}
                    </button>
                </div>

            </div >
        ) : (
            <div className="flex flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 rounded-md bg-gray-50 text-gray-600">
                <svg
                    className="w-10 h-10 mb-2 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9.75 9.75h.008v.008H9.75V9.75zm4.5 0h.008v.008H14.25V9.75zM9.75 14.25h.008v.008H9.75V14.25zm4.5 0h.008v.008H14.25V14.25z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 3v18h18V3H3zm3 3h12v12H6V6z"
                    />
                </svg>
                <h2 className='text-lg font-medium'>This report is under development</h2>
            </div>
        )
    );
};
export default DisbursementSheet;
